import {
  OrganizationContext,
  OrganizationContextProps,
} from '@web-app/hocs/organization';
import { ORG_IDS } from '@web-app/utils/api/whitelabel/organization-configs';
import { isProd } from '@web-app/utils/env.utils';
import { useContext } from 'react';

export const useIsBerryStreetOnly = (): boolean => {
  const { organizationId } =
    useContext<OrganizationContextProps>(OrganizationContext);

  if (!isProd) return true;
  return organizationId === ORG_IDS.BERRY_STREET;
};
